"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ToDearYou() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section data-section-id="237502" id="致親愛的你-to-dear-you" className="relative bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685908/img/artistic_hands_creation.png)] text-foreground py-[200px] px-4">
      {}
      <div className="absolute inset-0 bg-background/80 backdrop-blur-[2px]" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div ref={contentRef} className={`transition-all duration-1000 text-center ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-[2.25rem] font-semibold mb-12 text-foreground tracking-wider">
            致：親愛的你 <span className="italic text-2xl block md:inline md:ml-4 opacity-70">To: Dear You</span>
          </h2>

          <div className="max-w-2xl mx-auto">
            <p className="font-default text-xl leading-relaxed mb-6 text-foreground/90">
              這是一封寫給你的信。在繁忙的城市節奏中，我們往往遺忘了內心最真實的聲音。Dear EXA 的存在，是為了提供一個安靜的空間，讓你透過藝術重新與自己對話。
            </p>

            <p className="font-default text-xl leading-relaxed mb-12 text-foreground/80">
              表達藝術治療並非關於技巧的磨練，而是關於情感的流淌。在這裡，沒有對錯，只有真實。我們邀請你放下重擔，在創作的過程中，慢慢找回那份久違的平靜與力量。
            </p>

            <div className="pt-8 border-t border-border/30">
              <p className="font-default text-2xl font-light text-foreground mb-10 italic">
                「有些話，未必能說出口。但也許，能被慢慢創作出來。」 — Lammy
              </p>
              
              <Button asChild variant="outline" className="border-[hsl(10,70%,35%)] border bg-transparent hover:bg-transparent hover:underline text-[hsl(10,70%,35%)] rounded-md px-8 py-6 text-lg transition-all duration-300">
                <Link to="/AboutPage">
                  了解更多關於我們的故事
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}